var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-select',{attrs:{"remote":"","resource":"domains","params":_vm.domainParams,"select-props":{ placeholder: _vm.$t('rules.domain') }},on:{"change":_vm.handleChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }